import React, { useState } from "react";
import { Box, IconButton } from "@material-ui/core";
import { Edit } from "@material-ui/icons";
import locale from "@bonliva-crm/locale";
import { PipelineStatusModal } from "./pipeline-status-modal";

type Props = {
  consultantId: string;
  pipelineStatus?: string;
};

export function PipelineStatus(props: Props) {
  const [edit, setEdit] = useState<boolean>(false);

  return (
    <Box display="inline-flex" alignItems="center">
      <span>
        {(locale.consultantPipelineBoardHeaders[props.pipelineStatus] ||
          props.pipelineStatus) ??
          locale.missing}
      </span>

      <IconButton
        color="primary"
        style={{ padding: 0, marginLeft: 4 }}
        onClick={() => setEdit(true)}
      >
        <Edit />
      </IconButton>

      <PipelineStatusModal
        open={edit}
        onClose={() => setEdit(false)}
        consultantId={props.consultantId}
      />
    </Box>
  );
}
